import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const controlRoutes = [
  {
    path: routes.controls.uploadControl,
    element: lazyLoadRoutes("controls/pages/uploadControl"),
  },
  {
    path: routes.controls.broadcast,
    element: lazyLoadRoutes("controls/pages/Broadcast/index"),
  },
  {
    path: routes.controls.approvalSetting,
    element: lazyLoadRoutes("controls/pages/approval-setting"),
  },
  {
    path: routes.controls.approvalSettingList,
    element: lazyLoadRoutes("controls/pages/approval-setting/approval-list"),
  },
  {
    path: routes.controls.importUtility,
    element: lazyLoadRoutes("controls/pages/import-utility"),
  },

  {
    path: routes.controls.softwareLogReport,
    element: lazyLoadRoutes("controls/pages/software-log-report"),
  },
];
